import React from "react";
import InnerHTML from "../../utilities/innerHtml";
import { Div, Text, Row, Col, Image, StyleReset, Tag } from "atomize";

import { BLOCKS, MARKS } from "@contentful/rich-text-types";
import { IsValidUrl, updateActiveCampaignForm } from "../../utilities/helpers";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

const options = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (node, children) => {
      return (
        <Text
          textSize="heading4"
          m={String(children).length > 0 ? "1rem 0" : "0 !important"}
        >
          {children}
        </Text>
      );
    },
    [BLOCKS.HEADING_1]: (node, children) => (
      <Text
        tag="h1"
        m={{ t: "1rem", b: "3rem" }}
        textSize="heading1"
        textWeight="700"
      >
        {children}
      </Text>
    ),
    [BLOCKS.HEADING_2]: (node, children) => (
      <Text
        tag="h2"
        textSize="heading2"
        textWeight="700"
        m={{ t: "1rem", b: "2rem" }}
      >
        {children}
      </Text>
    ),
    [BLOCKS.HEADING_3]: (node, children) => (
      <Text
        tag="h3"
        textSize="heading3"
        textWeight="700"
        m={{ t: "1rem", b: "1rem" }}
      >
        {children}
      </Text>
    ),
    [BLOCKS.HEADING_4]: (node, children) => (
      <Text
        tag="h4"
        textSize="heading4"
        textWeight="700"
        m={{ t: "1rem", b: "1rem" }}
      >
        {children}
      </Text>
    ),
    [BLOCKS.HEADING_5]: (node, children) => (
      <Text
        textSize={{ xs: "subheader1", md: "paragraph3" }}
        textWeight="700"
        m={{ t: "1rem", b: "1rem" }}
      >
        {children}
      </Text>
    ),
    [BLOCKS.HEADING_6]: (node, children) => (
      <Div
        textSize={{ xs: "subheader1", md: "subheader2" }}
        textWeight="700"
        m={{ t: "1rem", b: "1rem" }}
        dangerouslySetInnerHTML={{ __html: children }}
      />
    ),
    [BLOCKS.OL_LIST]: (node, children) => (
      <ol>
        {node.content.map(item => {
          return documentToReactComponents(item, options);
        })}
      </ol>
    ),
    [BLOCKS.UL_LIST]: (node, children) => (
      <ul>
        {node.content.map(item => {
          return documentToReactComponents(item, options);
        })}
      </ul>
    ),
    [BLOCKS.LIST_ITEM]: (node, children) => <Text tag="li">{children}</Text>,
    [BLOCKS.HR]: (node, children) => <hr />,
    [BLOCKS.QUOTE]: (node, children) => (
      <Text
        tag="blockquote"
        // textSize="heading4"
        // m="1rem 0"
        // textAlign="center"
        // textWeight="700"
      >
        {children}
      </Text>
    ),
    [BLOCKS.EMBEDDED_ENTRY]: (node, children) => {
      if ("embed" in node.data.target.fields) {
        return (
          typeof window !== "undefined" && (
            <InnerHTML
              html={updateActiveCampaignForm(
                node.data.target.fields.embed["en-US"]
              )}
            ></InnerHTML>
          )
        );
      }

      return <Text>{children}</Text>;
    },
    [BLOCKS.EMBEDDED_ASSET]: (node, children) => {
      const type = node.data.target.fields.file["en-US"].contentType;

      switch (type) {
        case "image/gif":
        case "image/png":
        case "image/jpg":
        case "image/jpeg":
          return (
            <Image
              alt={
                node.data.target.fields.description &&
                node.data.target.fields.description["en-US"]
              }
              src={node.data.target.fields.file["en-US"].url}
            />
          );
      }
      return false;
    },
  },
};

const RichTextEditor = ({ json }) => documentToReactComponents(json, options);

export default RichTextEditor;
